import moment from 'moment';

moment.locale('ru');

export const isAppealNotStarted = exam => {
  const now = moment();

  if (now.isAfter(exam.appeal_end_date) && exam.appeal_start_date2) {
    return now.isBetween(exam.appeal_end_date, exam.appeal_start_date2, 'day');
  }

  return now.isBefore(exam.appeal_start_date);
};

export const getAvailableAppealDeadline = exam => {
  const now = moment();
  const isFirstDeadlineAvailable = now.isBetween(
    exam.appeal_start_date,
    exam.appeal_end_date,
    'day',
    '[]'
  );

  if (isFirstDeadlineAvailable) {
    return {
      appeal_deadline_from: exam.appeal_start_date,
      appeal_deadline_to: exam.appeal_end_date
    };
  }

  if (exam.appeal_start_date2) {
    const isSecondDeadlineAvailable = now.isBetween(
      exam.appeal_start_date2,
      exam.appeal_end_date2,
      'day',
      '[]'
    );

    if (isSecondDeadlineAvailable) {
      return {
        appeal_deadline_from: exam.appeal_start_date2,
        appeal_deadline_to: exam.appeal_end_date2
      };
    }
  }

  return null;
};

export default getAvailableAppealDeadline;
